import ApiBase from '../ApiBase';

class Question extends ApiBase {
    route = '/main-stage/sessions/:session/questions';
}

export default new Question();
